import { I18n } from '@calendly/i18n'

import { Summary } from './summary'
import { AccordionPanel } from '../../../../components/accordion'
import { Duration } from '../../duration'

export const DurationPanel = ({ isLocked, isReadOnly, ...props }) => (
  <AccordionPanel
    titleId="duration-label"
    title={I18n.t('publisher.event_types.availability.duration_fieldset.title')}
    subheader={<Summary />}
    {...props}
  >
    <Duration isLocked={isLocked} isReadOnly={isReadOnly} />
  </AccordionPanel>
)
